import { tv } from '~/utils/tv'

export const selectFieldVariants = tv({
  base: `
  flex justify-between w-full h-extrasmall p-none px-twopulse items-center text-text-neutral font-rdmodern flex-1 rounded-none leading-small z-80
  placeholder:opacity-transparent focus-visible:border-none focus-visible:outline-none tracking-onepulse
  `,
  variants: {
    size: {
      md: 'text-threepulse',
      ml: 'text-threeandhalfpulse',
      lg: 'text-threeandhalfpulse',
      xl: 'text-threeandhalfpulse',
    },
    readOnly: {
      true: 'text-text-neutral-readonly',
      false: '',
    },
    disabled: {
      true: 'text-text-neutral-disabled',
      false: '',
    },
    hasError: {
      true: 'bg-forms-fill-error',
      false: 'bg-forms-fill-filled',
    },
  },
  defaultVariants: {
    size: 'md',
    readOnly: false,
    disabled: false,
    hasError: false,
  },
})
